// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dkf9G","label":"styles_label__2SI80"};